import { ViewModel,View, ObservableArray } from "binder"
import  { ReceiptWreckedProductView } from "./receiptWreckedProduct-view"
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { getAsNumber, isNumber } from "src/uicomponents/components/utilities";

export class ReceiptWreckedProductViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'دریافت کالای معیوب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.loader = new ServerSideDataLoader(x => this.refreshPaged(x), 30);
        this.items = ObservableArray.create<lineItem>();
        
        this.loader.refresh();
    }

    GetDefaultView(): View <ViewModel> {
        return new ReceiptWreckedProductView();
    }
    public getTypeId(): string {
        return "VM-75738A6D-B0C5-492B-AC36-A6CB97427273"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set items(v: ObservableArray<lineItem>) { this._items = v; } public get items(): ObservableArray<lineItem> { return this._items; } private _items: ObservableArray<lineItem>;

    refresh() {
        this.loader.refresh();
    }

    async receipt(item: lineItem) {
        let popup = new SetFeePriceEditor(this);
        popup.clone(item);
        let result: any = await this.showPopup(popup);
        if (result != null) {
            this.refresh();
        }
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWreckedProducts', {
                FilteringInformation: filteringInformation,
                JustNotReceipt: true
            });
            this.items.update(...result.Products.map((x, i) => {
                let r = new lineItem(this);
                r.id = x.MeasuredProductId;
                r.index = i + 1;
                r.name = x.Name;
                r.code = x.Code;
                r.productCarModel = x.ProductCarModel;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.warehouseName = x.WarehouseName;
                r.description = x.Description;
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class lineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ReceiptWreckedProductViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel; } private _productCarModel: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance; } private _accessibleBalance: number;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set feePrice(v: number) { 
        this._feePrice = getAsNumber(v); 
    } public get feePrice(): number { return this._feePrice;} private _feePrice: number;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    
    private _typedParent:ReceiptWreckedProductViewModel;

    async receipt() {
        try {
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ReceiptWreckedProduct', {
                MeasuredProductId: this.id
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess('دریافت در انبار با موفقیت انجام شد','عملیات موفق');
            } else {
                throw new Error("error");  
            }
            this._typedParent.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this._typedParent.isLoading = false;
        }
        // this._typedParent.receipt(this);
    }
    
}

export class SetFeePriceEditor extends lineItem implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:ReceiptWreckedProductViewModel) {
        super(parent);
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    closePopup(resultCode: string = null) {
        return resultCode;
    }
    
    verify():string[]{
        let result :string[] =[];
        if(isNaN(this.feePrice)){
            result.push('قیمت پایه مشخص نشده است.')
        }
        return result;
    }

    async clone(product: lineItem) {
        this.code = product.code;
        this.name = product.name;
        this.id = product.id;
    }
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان دریافت کالا');
                return;
            }
            
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ReceiptWreckedProduct', {
                MeasuredProductId: this.id,
                FeePrice: this.feePrice
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess('دریافت در انبار با موفقیت انجام شد','عملیات موفق');
            } else {
                throw new Error("error");  
            }
            this.closePopup("done");
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async back(){
        this.closePopup();
    }

}